<template>
  <section class="product-features">
    <form method="post" @submit.prevent="onSend">
      <form-wrapper :validator="$v.form">
        <b-button
          :loading="sending"
          type="is-primary"
          native-type="submit"
          style="width: 240px; position: absolute; top: 10px; right: 10px;"
        >
          {{ $t('attributes.update_data') }}
        </b-button>

        <b-tabs v-model="activeTab" :animated="false" type="is-box">
          <b-tab-item>
            <template #header>
              <span>行程特色</span>
              <a
                :href="helpImageUrl('行程特色.png')"
                @click.prevent="onClickImage(helpImageUrl('行程特色.png'))"
                style="border: none; padding: 0 4px;"
              >
                <img
                  :src="helpImageUrl('行程特色.png')"
                  alt="行程特色"
                  width="32"
                />
              </a>
              <b-tooltip type="is-dark" position="is-right" label="(內頁)">
                <b-icon size="is-small" icon="help-circle-outline"></b-icon>
              </b-tooltip>
            </template>

            <editor
              ref="product_feature_editor"
              v-model="form.product_feature"
              :area="product.image_path"
              :height="editorHeight"
            ></editor>
          </b-tab-item>

          <b-tab-item>
            <template #header>
              <span>促銷訊息</span>
              <a
                :href="helpImageUrl('促銷訊息.png')"
                @click.prevent="onClickImage(helpImageUrl('促銷訊息.png'))"
                style="border: none; padding: 0 4px;"
              >
                <img
                  :src="helpImageUrl('促銷訊息.png')"
                  alt="促銷訊息"
                  width="32"
                />
              </a>
              <b-tooltip
                type="is-dark"
                position="is-right"
                label="(內頁)團名下方區塊"
              >
                <b-icon size="is-small" icon="help-circle-outline"></b-icon>
              </b-tooltip>
            </template>

            <editor
              ref="product_remark_editor"
              v-model="form.product_remark"
              :area="product.image_path"
              :height="editorHeight"
            ></editor>
          </b-tab-item>

          <b-tab-item>
            <template #header>
              <span>特色</span>
              <a
                :href="helpImageUrl('特色.png')"
                @click.prevent="onClickImage(helpImageUrl('特色.png'))"
                style="border: none; padding: 0 4px;"
              >
                <img :src="helpImageUrl('特色.png')" alt="特色" width="32" />
              </a>
              <b-tooltip
                type="is-dark"
                position="is-right"
                label="(內頁)日期下方區塊"
              >
                <b-icon size="is-small" icon="help-circle-outline"></b-icon>
              </b-tooltip>
            </template>

            <editor
              ref="remark6_editor"
              v-model="form.remark6"
              :area="product.image_path"
              :height="editorHeight"
            ></editor>
          </b-tab-item>
        </b-tabs>
      </form-wrapper>
    </form>

    <b-modal :active.sync="isImageModalActive">
      <p class="image">
        <img :src="selectedImageUrl" alt="" />
      </p>
    </b-modal>
  </section>
</template>

<script>
import { PRODUCTS_API } from '@/utils/apis'
import notifyService from '@/services/notifyService'
import Editor from '@/components/editors/Editor4'

export default {
  name: 'ProductFeatureForm',
  components: { Editor },

  props: {
    product: {
      required: true,
      type: Object
    }
  },
  data() {
    return {
      sending: false,
      form: this.extractFormValues(this.product),

      activeTab: 0,

      isImageModalActive: false,
      selectedImageUrl: null,

      windowHeight: window.innerHeight
    }
  },
  computed: {
    editorHeight() {
      return this.windowHeight - 360
    }
  },
  validations: {
    form: {
      product_feature: {},
      product_remark: {},
      remark6: {}
    }
  },
  watch: {
    product(newProduct) {
      this.form = this.extractFormValues(newProduct)
    }
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize)
    })
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize)
  },
  methods: {
    extractFormValues(data) {
      return {
        code: data.code,
        product_feature: data.product_feature || '',
        product_remark: data.product_remark || '',
        remark6: data.remark6 || ''
      }
    },
    async onSend() {
      this.form.product_feature = this.$refs.product_feature_editor.getData()
      this.form.product_remark = this.$refs.product_remark_editor.getData()
      this.form.remark6 = this.$refs.remark6_editor.getData()

      this.$v.$touch()

      if (this.$v.$invalid) {
        return
      }

      const api = `${PRODUCTS_API}/${this.form.code}/features`

      this.sending = true
      try {
        const res = await this.axios.put(api, this.form)
        this.$emit('updated', res.data.data)
        notifyService.success(`${this.$t('attributes.update_succeed')}`)
      } catch (e) {
        notifyService.update_error(e)
      } finally {
        this.sending = false
      }
    },
    onClickImage(url) {
      this.isImageModalActive = true
      this.selectedImageUrl = url
    },
    onResize() {
      this.windowHeight = window.innerHeight
    }
  }
}
</script>
